<script lang="ts">
    import { createEventDispatcher } from "svelte";

    import Button from "@components/Buttons/Button.svelte";
    import T from "@components/T.svelte";

    export let namespace: string;
    const dispatch = createEventDispatcher();

    const editReview = (event: Event) => {
        event.stopPropagation();
        dispatch("editReview");
    };
</script>

<Button variant="link" class="gw-rv-item__edit" on:click={editReview}>
    <T {namespace} translationKey="edit" />
</Button>

<style lang="postcss">
    :global(.gw-btn.gw-button.gw-rv-item__edit) {
        margin: var(--gap, 0.1em) 0 0;
        font-size: var(--gw-font-size-sm);
        text-transform: capitalize;
    }
</style>
